module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('future_bet')))])]), _vm._v(" "), _c('div', {
    staticClass: "future-bet"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.betting.numEvents),
      expression: "betting.numEvents"
    }, {
      name: "future-bet-validator",
      rawName: "v-future-bet-validator"
    }],
    attrs: {
      "id": "future",
      "type": "number",
      "autocomplete": "off",
      "disabled": _vm.isBettingDisabled
    },
    domProps: {
      "value": (_vm.betting.numEvents)
    },
    on: {
      "keydown": [_vm.checkChars, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        _vm.setFocus()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.betting.numEvents = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4483394b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/FutureBet.vue
// module id = 402
// module chunks = 0